import { Box, Typography } from "@mui/material";

export const getStatCardTooltipContent = (
  trendTooltip: { description: string; comparisonPeriod: string } | undefined,
  trend: string | undefined
) => {
  if (!trendTooltip) return null;

  return (
    <Box sx={{ p: 1 }}>
      <Typography
        sx={{
          fontSize: "10px",
          fontWeight: "normal",
          mb: 1,
          color: "#FFFFFF",
        }}
      >
        {trendTooltip.description}
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: "bold",
          mb: 0.5,
          color: "#FFFFFF",
        }}
      >
        {trend}
      </Typography>
      <Typography
        sx={{ fontSize: "10px", fontWeight: "normal", color: "#FFFFFF" }}
      >
        {trendTooltip.comparisonPeriod}
      </Typography>
    </Box>
  );
};
